/**
 * "Show only core forms" toggle (spec §3 step 2 / §9.1).
 *
 * Default ON: hides record producers that aren't documented in KB0053029
 * (i.e. `sn_record_producers.kb_number IS NULL`). The toggle is sticky
 * across sessions; flip it to also surface non-core local forms in
 * StreamScreen (Phase 3 wires up the data path).
 */

import { usePersistentState } from './storage';

const KEY = 'intake.ui.coreOnly.v1';

export function useCoreOnly(): {
  coreOnly: boolean;
  setCoreOnly: (next: boolean) => void;
} {
  const [coreOnly, set] = usePersistentState<boolean>(KEY, true);
  return { coreOnly, setCoreOnly: set };
}
